import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './pool_cover.less'
import CrossFadeTransition from 'components/common/transitions/cross_fade'
import ColoredRadio from 'components/colored_radio'
import ImageFileField from 'components/common/image_file_field'
import ImagePreview from 'components/image_preview'
import Separator from 'components/common/separator'
import { getI18n } from 'client/i18n'
import {
  GRADIENT_COLORS,
  COVER_IMAGE_MAX_TOTAL_SIZE,
} from 'shared/shared_consts'

const DEFAULT_PAN = 50
const i18n = getI18n('components/pages/create/pool_cover')

class PoolCover extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
  }

  state = {
    isLoading: false,
  }

  handleImageRemove = () => {
    const {
      fields: { backgroundImage, backgroundImageFilename, backgroundPan },
    } = this.props
    backgroundPan.onChange(DEFAULT_PAN)
    backgroundImage.onChange(undefined)
    backgroundImageFilename.onChange(undefined)
  }

  handleImageChange = val => {
    const {
      fields: { backgroundImage, backgroundImageFilename, backgroundPan },
    } = this.props
    backgroundPan.onChange(DEFAULT_PAN)
    backgroundImage.onChange(val.url)
    backgroundImageFilename.onChange(val.name)
  }

  handleImageLoad = isLoading => {
    this.setState({ isLoading })
  }

  render() {
    const {
      fields: { gradientColor, backgroundImage, backgroundPan },
    } = this.props
    return (
      <div>
        <div styleName="title" role="heading" aria-level="1">
          {i18n('title')}
        </div>
        <CrossFadeTransition>
          {backgroundImage.value ? (
            <div key="with-value">
              <div
                styleName="image-container"
                className={this.state.isLoading ? 'vx_has-spinner-medium' : ''}
              >
                <ImagePreview
                  imageUrl={backgroundImage.value}
                  pan={parseInt(backgroundPan.value)}
                  onPanChange={backgroundPan.onChange}
                  onImageChange={this.handleImageChange}
                  onImageLoad={this.handleImageLoad}
                />
              </div>
              <p styleName="tip">{i18n('upload_tip')}</p>
              <Separator type="dotted" />
              <a
                data-pa-click="removeImage"
                styleName="remove-image"
                href="javascript:;"
                onClick={this.handleImageRemove}
              >
                {i18n('remove_image')}
              </a>
              <button
                data-pa-click="done"
                styleName="done-btn"
                className="vx_btn vx_btn-block"
              >
                {i18n('done')}
              </button>
            </div>
          ) : (
            <div key="without-value">
              <div
                styleName="upload-btn-container"
                className={this.state.isLoading ? 'vx_has-spinner-medium' : ''}
              >
                <ImageFileField
                  onImageLoad={this.handleImageLoad}
                  restrictedTotalSize={COVER_IMAGE_MAX_TOTAL_SIZE}
                  onChange={this.handleImageChange}
                >
                  <a
                    data-pa-click="uploadImage"
                    href="javascript:;"
                    className="vx_btn vx_btn-block vx_btn-secondary vx_btn-medium"
                  >
                    {i18n('upload')}
                  </a>
                </ImageFileField>
              </div>
              <p styleName="tip">{i18n('upload_tip')}</p>
              <div>
                <Separator type="dotted" text={i18n('or')} />
                <div styleName="choose-color">{i18n('choose_background')}</div>
                <div styleName="color-form-container">
                  <div styleName="color-form">
                    {Object.keys(GRADIENT_COLORS).map((colorName, index) => {
                      return (
                        <ColoredRadio
                          color={colorName}
                          fieldProps={gradientColor}
                          key={index}
                        />
                      )
                    })}
                  </div>
                </div>
              </div>
              <button
                data-pa-click="done"
                data-nemo="done"
                styleName="done-btn"
                className="vx_btn vx_btn-block"
              >
                {i18n('done')}
              </button>
            </div>
          )}
        </CrossFadeTransition>
      </div>
    )
  }
}

export default cssModules(PoolCover, styles)
